import { render, staticRenderFns } from "./Pagination.vue.js?vue&type=template&id=2da78823&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Pagination.vue?vue&type=template&id=2da78823&scoped=true"
import script from "./Pagination.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue.scss?vue&type=style&index=0&id=2da78823&prod&scoped=true&lang=scss!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Pagination.vue?vue&type=style&index=0&id=2da78823&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da78823",
  null
  
)

export default component.exports